
import React, { useEffect } from 'react';
import { Header } from "@/components/Header";
import { FooterSection } from "@/components/FooterSection";
import CaseManagementContent from "@/components/expertise/CaseManagementContent";

const CaseManagement = () => {
  useEffect(() => {
    document.title = "AI Case Management Solutions | DocketLabs";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'AI-powered case management for law firms. Streamline workflows, track progress & improve organization. Transform your practice.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'AI-powered case management for law firms. Streamline workflows, track progress & improve organization. Transform your practice.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <>
      <Header />
      <div className="pt-24 bg-background min-h-screen">
        <CaseManagementContent />
      </div>
      <FooterSection />
    </>
  );
};

export default CaseManagement;
